import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ReceiptBillDetails } from './receipt.model';

@Injectable({
  providedIn: 'root',
})
export class ReceiptService {
  billDetails: BehaviorSubject<ReceiptBillDetails> = new BehaviorSubject(null);
  billDetails$ = this.billDetails.asObservable();

  setBillDetails(billDetails) {
    this.billDetails.next(billDetails);
  }
}
